<template>
  <div class="park">
    <div>
    <div class="park-btn">
      <el-button type="primary" size="mini" @click="updateDicDialog()">添加数据</el-button>
    </div>
    <div class="main-table">
      <el-table
        :data="dicList"
        border
        style="width: 100%">
        <el-table-column prop="id" label="ID"> </el-table-column>
        <el-table-column prop="name" label="名称"> </el-table-column>
        <el-table-column prop="method" label="方法"> </el-table-column>
        <el-table-column label="创建日期">
          <template slot-scope="scope">
            <div>{{$dtime(scope.row.createTime).format('YYYY-MM-DD HH:mm:ss')}}</div>
          </template>
        </el-table-column>
        <el-table-column
          label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="updateDicDialog(scope.row)">修改</el-button>
            <!--<el-button type="text" size="mini" @click="deleteDicDialog(scope.row)">{{scope.row.isDelete == true ? '恢复':'删除'}}</el-button>-->
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-bottom:30px;margin-top:20px;">
        <el-pagination
          background
          layout="total,prev, pager, next"
          :total="dataArgs.total"
          :page-size="dataArgs.take"
          :current-page="dataArgs.skip/dataArgs.take+1"
          @current-change="changePage" style="float:right;">
        </el-pagination>
      </div>
    </div>
    </div>
    <el-dialog
      title="API操作"
      :visible.sync="isUpdateShow"
      width="70%">
      <el-form ref="form" :model="dicEntity" label-width="80px">
        <el-form-item label="名称">
          <el-input v-model="dicEntity.name"></el-input>
        </el-form-item>
        <el-form-item label="方法">
          <el-input v-model="dicEntity.method"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isUpdateShow = false">取 消</el-button>
        <el-button type="primary" @click="updateDic">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="!dicEntity.isDelete ? '删除字典':'恢复删除'"
      :visible.sync="isDeleteShow"
      width="50%">
      <span>确定要{{!dicEntity.isDelete ? '删除字典':'恢复删除'}}么？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isDeleteShow = false">取 消</el-button>
        <el-button type="primary" @click="deleteDic">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getPermissions,updatePermission,addPermission } from './api.gql'
import gql from "graphql-tag";
export default {
  name: 'dic',
  data () {
    return {
      dicEntity:{
        name:null,
        method:null,
      },
      dicList:null,
      dataArgs:{
        take:20,
        skip:0,
        order:'-createTime',
        count:null,
      },
      isUpdateShow:false,
      isDeleteShow:false,
    }
  },
  created(){
    this.getPermissionList()
    // this.getDicTypeList()
  },
  methods:{
    getPermissionList(){
       this.$global.GraphqlQuery(this,getPermissions,this.dataArgs,).then(res=>{
        this.dataArgs.total = res.total
        this.dicList = res.data
        this.isUpdateShow = false
      })
      // this.$global.GraphqlQuery(this,{
      //   query: gql`query getPermissions($order: String, $skip: Int = 0, $take: Int) {
      //     getPermissions(order: $order, skip: $skip, take: $take){
      //       status,
      //       data {
      //         id,
      //         name,
      //         method,
      //         createTime
      //       },
      //       total
      //     }
      //   }`,
      //   // Parameters
      //   variables: this.dataArgs,
      // }).then((res) => {
      //   this.dataArgs.total = res.data.getPermissions.total
      //   this.dicList = res.data.getPermissions.data
      //   this.isUpdateShow = false
      // })
    },
    updateDicDialog(item){
      if(item){
        this.dicEntity = item
      }else {
        this.dicEntity.id = null
      }
      this.isUpdateShow = !this.isUpdateShow
    },
    changeTypeRadio(){
      this.dataArgs.skip = 0;
      this.getPermissionList()
    },
    changePage(val){
      this.dataArgs.skip = (val-1)*this.dataArgs.take
      this.getPermissionList()
    },
    updateDic(){
      let {name,method} = this.dicEntity
      const subEntity = {name,method}
      
      if(this.dicEntity.id){
        this.$global.GraphqlMutation(this,updatePermission,{
          // mutation: gql`mutation ($id:String! ,$data: PermissionInput!) {
          //   updatePermission(id:$id, data: $data) {
          //     status
          //   }
          // }`,
          // Parameters
     
            id:this.dicEntity.id,
            data: subEntity

        }).then(res=>{
          this.getPermissionList();
        })
      } else {
        this.$global.GraphqlMutation(this,addPermission,{
          // Parameters
            data: subEntity,
        }).then(res=>{
          this.getPermissionList();
        })
      }
    },
    deleteDicDialog(item){
      this.dicEntity = item
      this.isDeleteShow = !this.isDeleteShow
    },
    deleteDic(){
    this.$apollo.mutate({
        mutation: gql`mutation ($id: String!) {
          deleteDictionary(id: $id) {
            status
          }
        }`,
        // Parameters
        variables: {
          id: 1,
        },
      }).then((res) => {
        console.log(res)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.park{
  height: 100%;
}
.park-btn {
  margin: 10px;
}
.park-red {
  background-color: red;
  color:white;
  padding:5px;
}
.park-green{
  background-color: green;
  color: white;
  padding:5px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/configuration/API.vue